import { cartDetailsFragment } from '../queries/get-cart-query'

const cartCreateMutation = `
  mutation cartCreate(
    $input: CartInput = {}
    $country: CountryCode
    $language: LanguageCode
  ) @inContext(country: $country, language: $language) {
    cartCreate(input: $input) {
      userErrors {
        code
        field
        message
      }
      cart {
        ...cartDetails
      }
    }
  }

  ${cartDetailsFragment}
`

export default cartCreateMutation
